"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookUpController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const look_up_service_1 = require("./look-up.service");
const create_look_up_dto_1 = require("./dto/create-look-up.dto");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const update_look_up_dto_1 = require("./dto/update-look-up.dto");
const look_up_query_param_dto_1 = require("./dto/look-up-query-param.dto");
const look_up_swagger_1 = require("./look-up.swagger");
let LookUpController = class LookUpController {
    constructor(lookUpService) {
        this.lookUpService = lookUpService;
    }
    /**
     * Retrieves all LookUps by delegating the service.
     */
    async getAllLookUps(res, queries) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getAllLookUps *");
            const serviceStartTime = Date.now(); // Record the service execution start time
            const lookUps = await this.lookUpService.getAllLookUps(queries?.search, queries?.sortBy, queries?.sortOrder, queries?.page, queries?.limit);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getAllLookUps * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getAllLookUps * ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "LookUps retrieved successfully", lookUps));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, "An error occurred while retrieving LookUps"));
        }
    }
    /**
     * Creates a new LookUp by delegating the service.
     */
    async createLookUp(createLookUpDto, res) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * createLookUp *");
            const serviceStartTime = Date.now(); // Record the service execution start time
            const lookUp = await this.lookUpService.createLookUp(createLookUpDto);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * createLookUp * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * createLookUp * ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.CREATED)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.CREATED, "LookUp created successfully", lookUp));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                ? error.message
                : "An error occurred while creating LookUp"));
        }
    }
    /**
     * Get lookup values by lookup name by delegating the service.
     */
    async getLookUpsByName(lookUpName, res) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getLookUpsByName *");
            if (!lookUpName) {
                return res
                    .status(common_1.HttpStatus.BAD_REQUEST)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, "lookUpName is required"));
            }
            const serviceStartTime = Date.now(); // Record the service execution start time
            const data = await this.lookUpService.getLookUpsByName(lookUpName.toUpperCase());
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getLookUpsByName * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getLookUpsByName * ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "LookUps retrieved successfully", data));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                ? error.message
                : "An error occurred while retrieving LookUps"));
        }
    }
    /**
     * Get lookup values by lookup key by delegating the service.
     */
    async getLookUpsByKey(lookUpKey, res) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getLookUpsByKey *");
            const serviceStartTime = Date.now(); // Record the service execution start time
            if (!lookUpKey) {
                return res
                    .status(common_1.HttpStatus.BAD_REQUEST)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, "lookUpKey is required"));
            }
            const data = await this.lookUpService.getLookUpsByKey(lookUpKey.toUpperCase());
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getLookUpsByKey * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getLookUpsByKey * ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "LookUps retrieved successfully", data));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                ? error.message
                : "An error occurred while retrieving LookUps"));
        }
    }
    /**
     * Retrieves distinct lookup names.
     */
    async getDistinctLookUpNames(res) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getDistinctLookUpNames *");
            const serviceStartTime = Date.now(); // Record the service execution start time
            const distinctNames = await this.lookUpService.getDistinctLookUpNames();
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getDistinctLookUpNames * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getDistinctLookUpNames * ${responseTime - requestStartTime}ms`);
            return res.status(common_1.HttpStatus.OK).json({
                statusCode: common_1.HttpStatus.OK,
                message: "Distinct lookup names retrieved successfully",
                data: distinctNames,
            });
        }
        catch (error) {
            return res.status(common_1.HttpStatus.INTERNAL_SERVER_ERROR).json({
                statusCode: common_1.HttpStatus.INTERNAL_SERVER_ERROR,
                message: "An error occurred while retrieving distinct lookup names",
            });
        }
    }
    /**
     * Retrieves a single LookUp by ID by dleegating the service.
     */
    async getLookUpById(res, id) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getLookUpById * ");
            const serviceStartTime = Date.now(); // Record the service execution start time
            const lookUp = await this.lookUpService.getLookUpById(+id);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getLookUpById * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getLookUpById * ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "LookUp retrieved successfully", lookUp));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                ? error.message
                : "An error occurred while retrieving LookUp"));
        }
    }
    /**
     * Updates a LookUp by ID, by delegating the service.
     */
    async updateLookUpById(res, id, updateLookUpDto) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * updateLookUpDto * ");
            const serviceStartTime = Date.now(); // Record the service execution start time
            const lookUp = await this.lookUpService.updateLookUpById(+id, updateLookUpDto);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * updateLookUpDto * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * updateLookUpDto * ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "LookUp updated successfully", lookUp));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                ? error.message
                : "An error occurred while updating LookUp"));
        }
    }
    /**
     * Deletes a LookUp by ID, by delegating the service.
     */
    async deleteLookUpById(res, id) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * deleteLookUpById *");
            const serviceStartTime = Date.now(); // Record the service execution start time
            await this.lookUpService.deleteLookUpById(+id);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * deleteLookUpById * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * deleteLookUpById * ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "LookUp deleted successfully"));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                ? error.message
                : "An error occurred while deleting LookUp"));
        }
    }
    /**
     * Retrieves LookUp records based on a list of lookup names.
     */
    async getLookUpsByNames(body, res) {
        try {
            const { lookupNames } = body;
            // Validate the input
            if (!Array.isArray(lookupNames) || lookupNames.length === 0) {
                return res
                    .status(common_1.HttpStatus.BAD_REQUEST)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, "lookupNames must be a non-empty array"));
            }
            const lookUpRecords = await this.lookUpService.getLookUpsByNames(lookupNames);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "LookUp records retrieved successfully", lookUpRecords));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                ? error.message
                : "An error occurred while retrieving LookUp records"));
        }
    }
};
exports.LookUpController = LookUpController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, look_up_swagger_1.getAllLookUpsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Query)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_b = typeof look_up_query_param_dto_1.GetLookUpsQueryDto !== "undefined" && look_up_query_param_dto_1.GetLookUpsQueryDto) === "function" ? _b : Object]),
    tslib_1.__metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], LookUpController.prototype, "getAllLookUps", null);
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, look_up_swagger_1.createLookUpSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_d = typeof create_look_up_dto_1.CreateLookUpDto !== "undefined" && create_look_up_dto_1.CreateLookUpDto) === "function" ? _d : Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
], LookUpController.prototype, "createLookUp", null);
tslib_1.__decorate([
    (0, common_1.Get)("value"),
    (0, look_up_swagger_1.getLookUpByValueSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)("name")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], LookUpController.prototype, "getLookUpsByName", null);
tslib_1.__decorate([
    (0, common_1.Get)("key"),
    (0, look_up_swagger_1.getLookUpsByKeySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)("key")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], LookUpController.prototype, "getLookUpsByKey", null);
tslib_1.__decorate([
    (0, common_1.Get)("distinct-names"),
    (0, look_up_swagger_1.getDistinctLookUpNamesSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
], LookUpController.prototype, "getDistinctLookUpNames", null);
tslib_1.__decorate([
    (0, common_1.Get)(":id"),
    (0, look_up_swagger_1.getLookUpByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Param)("id")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, String]),
    tslib_1.__metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
], LookUpController.prototype, "getLookUpById", null);
tslib_1.__decorate([
    (0, common_1.Put)(":id"),
    (0, look_up_swagger_1.updateLookUpByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Param)("id")),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, String, typeof (_h = typeof update_look_up_dto_1.UpdateLookUpDto !== "undefined" && update_look_up_dto_1.UpdateLookUpDto) === "function" ? _h : Object]),
    tslib_1.__metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
], LookUpController.prototype, "updateLookUpById", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":id"),
    (0, look_up_swagger_1.deleteLookUpByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Param)("id")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, String]),
    tslib_1.__metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
], LookUpController.prototype, "deleteLookUpById", null);
tslib_1.__decorate([
    (0, common_1.Post)("lookup-values-by-name"),
    (0, look_up_swagger_1.getLookUpsByNamesSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
], LookUpController.prototype, "getLookUpsByNames", null);
exports.LookUpController = LookUpController = tslib_1.__decorate([
    (0, common_1.Controller)("look-up"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof look_up_service_1.LookUpService !== "undefined" && look_up_service_1.LookUpService) === "function" ? _a : Object])
], LookUpController);
